var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuySubscription({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7732 1.47496L10.7457 1.53912L8.08734 7.70829H5.47484C4.85151 7.70829 4.25568 7.83662 3.71484 8.06579L5.31901 4.23412L5.35568 4.14246L5.41984 3.99579C5.43818 3.94079 5.45651 3.88579 5.48401 3.83996C6.68484 1.06246 8.04151 0.429958 10.7732 1.47496Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7126 7.89164C15.3001 7.76331 14.8601 7.70831 14.4201 7.70831H8.08594L10.7443 1.53914L10.7718 1.47498C10.9093 1.52081 11.0376 1.58498 11.1751 1.63998L13.2009 2.49248C14.3284 2.95998 15.1168 3.44581 15.5934 4.03248C15.6851 4.14248 15.7584 4.24331 15.8226 4.36248C15.9051 4.49081 15.9693 4.61914 16.0059 4.75664C16.0426 4.83914 16.0701 4.92164 16.0884 4.99498C16.3359 5.76498 16.1893 6.70914 15.7126 7.89164Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8959 12.1818V13.9693C18.8959 14.1527 18.8867 14.336 18.8776 14.5193C18.7034 17.7185 16.9159 19.3318 13.5242 19.3318H6.37422C6.15422 19.3318 5.93422 19.3135 5.72339 19.286C2.80839 19.0935 1.25005 17.5352 1.05755 14.6202C1.03005 14.4093 1.01172 14.1893 1.01172 13.9693V12.1818C1.01172 10.3393 2.13005 8.7535 3.72505 8.066C4.27505 7.83683 4.86172 7.7085 5.48505 7.7085H14.4317C14.8809 7.7085 15.3209 7.77266 15.7242 7.89183C17.5484 8.451 18.8959 10.156 18.8959 12.1818Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3175 4.23413L3.71333 8.0658C2.11833 8.7533 1 10.3391 1 12.1816V9.4958C1 6.89246 2.85167 4.71996 5.3175 4.23413Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8943 9.49539V12.1812C18.8943 10.1646 17.556 8.45039 15.7227 7.90039C16.1993 6.70873 16.3368 5.77373 16.1077 4.99456C16.0893 4.91206 16.0618 4.82956 16.0252 4.75623C17.7302 5.63623 18.8943 7.44206 18.8943 9.49539Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuySubscription);
export default __webpack_public_path__ + "static/media/buySubscription.12195a36f4dcaefae783dfee876ee368.svg";
export { ForwardRef as ReactComponent };